import mixitup from "mixitup";

// import getMixitupPagination from "./lib/mixitup-pagination.customised.js"; //quiet
import pagination from "./lib/mixitup-pagination.customised.js"; //quiet;
// import mixitupMultifilter from "./lib/mixitup-multifilter.customised.js"; //quiet

mixitup.use(pagination);

let MixContainers = [];

const body = document.querySelector("body");

function pageLinksHandler(e) {
    var dataAttr = "data-filter";
    var el_link = e.target.closest("a");

    if (el_link && el_link.hasAttribute(dataAttr)) {
        var filtersID = el_link.getAttribute(dataAttr);

        var activeFilter = document
            .querySelector(filtersID)
            .querySelector(".mixitup-control-active .link-filter-title");

        el_link.href = `${el_link.getAttribute("href")}?filter=${
            activeFilter.textContent
        }`;
    }
}

function getPaginationConfig(limitLookup) {
    var styles = window.getComputedStyle(
        document.querySelector(".column-counter")
    );

    const columms = parseInt(styles.fontSize);

    return { limit: limitLookup[columms] };
}

function resizeHandler() {
    MixContainers.forEach(({ mixer, limitLookup }) => {
        mixer.paginate(getPaginationConfig(limitLookup), false);
    });
}

export default {
    init: function () {
        const mixers = document.querySelectorAll(".mixitup-container");

        mixers.forEach((mixer_el) => {
            const { mixitupOptions, columnLimitLookup } = mixer_el.dataset;

            const limitLookup = JSON.parse(columnLimitLookup);

            const mixer = mixitup(
                mixer_el,
                Object.assign(JSON.parse(mixitupOptions), {
                    pagination: getPaginationConfig(limitLookup),
                    callbacks: {
                        onMixClick: function (_, originalEvent) {
                            if (
                                originalEvent.currentTarget.classList.contains(
                                    "blocklink"
                                )
                            ) {
                                return false;
                            }
                        }
                    }
                })
            );
            MixContainers = [...MixContainers, { mixer, limitLookup }];
        });

        //Filters pagination
        if (document.querySelectorAll("[class^='PageLinks']").length > 0) {
            body.addEventListener("mousedown", pageLinksHandler);
        }

        window.addEventListener("resize", resizeHandler);
    },
    cleanup: function () {
        MixContainers.forEach(({ mixer }) => {
            mixer.destroy();
        });

        MixContainers = [];

        window.removeEventListener("resize", resizeHandler);

        body.removeEventListener("mousedown", pageLinksHandler);
    }
};
